var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53281 0.220312C6.23906 -0.0734375 5.76406 -0.0734375 5.47344 0.220312L0.220313 5.47031C-0.0734375 5.76406 -0.0734375 6.23906 0.220313 6.52969C0.514063 6.82031 0.989063 6.82344 1.27969 6.52969L5.24844 2.56094V13.2516C5.24844 13.6672 5.58281 14.0016 5.99844 14.0016C6.41406 14.0016 6.74844 13.6672 6.74844 13.2516V2.56094L10.7172 6.52969C11.0109 6.82344 11.4859 6.82344 11.7766 6.52969C12.0672 6.23594 12.0703 5.76094 11.7766 5.47031L6.53281 0.220312Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f6c798404f11b0ed9ac43d31c4c06301.svg";
export { ForwardRef as ReactComponent };